import $ from 'jquery';

import endpoint from '../environments/endpoints';

// TODO #pagination #refactor Does this have to somehow be reconciliated with redux?
//      How does redux work then the result of the API fetch does not have to be dispatched
//      throughout the whole application but only on a certain sub-page? 
export function getStavkeZaProdajuPaginated(q, poslovnicaId, page, pageSize, onSuccess, onError) {
    $.ajax({
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + sessionStorage.token
        },
        url: endpoint.apiEndpoint + 'prodaja/stavke' +
            '?q=' + q +
            '&poslovnicaId=' + poslovnicaId +
            '&page=' + page +
            '&pageSize=' + pageSize
    })
        .done(onSuccess)
        .fail(onError);
}
